import { Component, Input } from '@angular/core';
import { QueryParamsHandling } from '@angular/router';

import { VtmnPlayButtonSizeEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-size.enum';
import { VtmnPlayButtonVariantEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-variant.enum';
import { VtmnPlayButtonShapeEnum } from '../vtmn-play-button/enum/vtmn-play-button-shape.enum';

@Component({
  selector: 'app-navigation-button',
  templateUrl: './navigation-button.component.html',
  styleUrls: ['./navigation-button.component.scss'],
})
export class NavigationButtonComponent {
  @Input() public buttonClass? = '';
  @Input() public disabled = false;
  @Input() public hasEmit = false;
  @Input() public href: string;
  @Input() public isSubmit = false;
  @Input() public queryParameters = {};
  @Input() public queryParametersHandling: QueryParamsHandling = '';
  @Input() public routerLinkButton: string;
  @Input() public size = VtmnPlayButtonSizeEnum.MEDIUM;
  @Input() public variant = VtmnPlayButtonVariantEnum.PRIMARY;
  @Input() public shape = VtmnPlayButtonShapeEnum.SQUARED;

  public get isButton(): boolean {
    return this.disabled || this.isSubmit;
  }
}
